import React from "react";
import { FlexGrid } from 'components/Elements';
import { HorizontalScroll } from 'components/HorizontalScroll'
import { useResponsiveProp } from "hooks/useBreakpoint";

export const ButtonGroup = ({ scroll, ...props }) => (
    useResponsiveProp(scroll)
        ? <HorizontalScroll fade {...props} />
        : <FlexGrid gutter={1} spacing={1} {...props} />
)